module.exports = __webpack_public_path__ + "static/media/JUBLFOOD_F1.6e860c39.txt";